var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBushfire(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 110",
    style: {
      enableBackground: "new 0 0 110 110"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-burning-tree-6601730",
    transform: "translate(-7.162 -6.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    className: "st-bushfire",
    d: "M90,26.9c-4.2,8.5-9.5,16.4-15.6,23.6C69.7,56.7,66,62.3,66,69.2c0.4,7.2,4.8,13.5,11.4,16.2 c-2.2-6.1-1.6-12.9,1.8-18.5c0.7-1.1,2.1-1.4,3.2-0.7c0.7,0.4,1.1,1.2,1,2l0,0c0.2,1.5,0.7,3,1.5,4.3c1.4-5.5,1.3-11.3-0.1-16.9 c-0.2-1.2,0.6-2.4,1.8-2.7c0.5-0.1,1,0,1.5,0.2l0,0c6.5,3.5,16.9,21.7,13.2,32.1c6.6-2.8,11-9.1,11.3-16.2c0-5.8-5.4-15.4-8.9-21.2 c-1.2,7.7-7.7,7-9.8,3C88.8,41,93.6,33.4,90,26.9L90,26.9z M26,62.9H15.2L34,39.4h4.7c1.3,0,2.2-1.1,2.2-2.4c0-1.2-1-2.2-2.2-2.2 H27.9L48,9.6L68,34.8h-4.9l0,0c-1.3,0-2.3,1-2.3,2.3c0,0.5,0.2,1,0.5,1.4l8.4,10.6c-4.7,6.3-8.3,12.3-8.3,20.1 C61.7,77,66,84.2,72.8,88H10.7l16.4-20.5h6.5c1.3,0,2.2-1.1,2.2-2.4c0-1.2-1-2.2-2.2-2.2H26L26,62.9z M43.1,92.6v20.2h9.8V92.6 L43.1,92.6z M89.2,88c-7.9-0.1-9.4-7-8.2-13.2c1.2,2,3.2,4.1,5.7,3c3.9-1.8,4.1-11.7,3.6-16.2C95.2,68.2,104.6,88.2,89.2,88 L89.2,88z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBushfire);
export default __webpack_public_path__ + "static/media/bushfire.3a9452a27fa192393d3481ea07b5fbef.svg";
export { ForwardRef as ReactComponent };